export default {
  willDeleteOn: 'This draft will be deleted on {deleteDay}',
  draftRules: 'You can save up to {limitDraft} drafts. Each draft is kept for {draftExpiredTime} days from its creation date. Remember to publish it in time.',
  created: 'Created:'
}